import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import {
  clearFilterJadai,
  clearJadaiDetail,
  setFilterJadai,
  setJadaiID,
} from "./jadaiSlice";
import { deleteJadai, findAllJadai } from "./services/jadai.services";
import { FaEye } from "react-icons/fa";

const Jadai: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearJadaiDetail());
      dispatch(setCurrentPage(0));
    };
  }, []);

  const handleProcessCreate = () => {
    navigate("/jadai/create");
  };
  return (
    <>
      <DeleteJadaiDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Jadai Issue List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleProcessCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <JadaiGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const JadaiGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const JadaiList = useAppSelector((state) => state.jadai.JadaiList);
  const loading = useAppSelector((state) => state.jadai.loading);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  
  const FilterJadai = useAppSelector((state) => state.jadai.FilterJadai);

  useEffect(() => {
    const payload = {
      ...FilterJadai,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllJadai(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const MyEditCommandCell = (props: any) => {
    const handleEditItem = (jadai_issue_guid: string) => {
      navigate("/jadai/edit", {
        state: { ID: jadai_issue_guid },
      });
    };

    const handleOpenDeleteDialog = (jadai_issue_guid: number) => {
      dispatch(openDialog("deleteJadaiIssue"));
      dispatch(setJadaiID(jadai_issue_guid));
    };
    const handlePrint = (jadai_issue_guid: string) => {
      window.open(`/jadaiissue/${jadai_issue_guid}`, "_blank");
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem.jadai_issue_guid)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.jadai_issue_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            themeColor="tertiary"
            onClick={() => handlePrint(props.dataItem.jadai_issue_guid)}
          >
            <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 4 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const JadaiFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.jadai.FilterJadai}
        setFilterAction={setFilterJadai}
        clearFilterAction={clearFilterJadai}
        fetchDataAction={findAllJadai}
        pagination={{ case: "lowercase" }}
      />
    ),
    []
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        className="responsive-table"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={filter ? filterBy(JadaiList, filter) : JadaiList}
        total={JadaiList[0]?.itemcount || JadaiList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          width={100}
          field="issue_no"
          title="Issue No"
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/jadai/edit", {
                      state: { ID: props.dataItem?.jadai_issue_guid },
                    })
                  }
                >
                  {props.dataItem?.issue_no}
                </div>
              </td>
            ),
          }}
        />
        <Column
          field="issue_date"
          title="Issue Date"
          width={120}
          cells={{ filterCell: JadaiFilterCell }}
        />
        <Column
          field="karigar_name"
          title="Karigar Name"
          width={200}
          cells={{ filterCell: JadaiFilterCell }}
        />
        {/* <Column
          field="approx_delivery_date"
          title="Approx Delivery Date"
          width={180}
          cells={{ filterCell: JadaiFilterCell }}
        /> */}
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="ghat_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteJadaiDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const JadaiID = useAppSelector((state) => state.jadai.JadaiID);
  const FilterJadai = useAppSelector((state) => state.jadai.FilterJadai);

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (jadai_issue_guid: any) => {
    const getpayload = {
      ...FilterJadai,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    if (jadai_issue_guid) {
      const response = await dispatch(deleteJadai(jadai_issue_guid));
      dispatch(setCurrentPage(0));
      if (response.payload?.Data.Status === 200) {
        dispatch(findAllJadai(getpayload));
        dispatch(closeDialog());
        dispatch(clearJadaiDetail());
      } else {
        dispatch(findAllJadai(getpayload));
        dispatch(closeDialog());
        dispatch(clearJadaiDetail());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteJadaiIssue" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Jadai Issue?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Jadai Issue?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(JadaiID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Jadai;
